const phases = [
  { step: '01', title: 'Диагностика', icon: 'ri-search-eye-line', desc: 'Анализ текущей ситуации: KPI, воронка, компетенции менеджеров, интервью с руководителями.' },
  { step: '02', title: 'Интервью', icon: 'ri-mic-line', desc: 'Глубинные интервью с менеджерами и РОПами: понимаем реальные проблемы, а не то, что «на поверхности».' },
  { step: '03', title: 'Подготовка программы', icon: 'ri-file-list-3-line', desc: 'Адаптация программы под отрасль, продукт, цикл сделки и уровень подготовки команды.' },
  { step: '04', title: 'Обучение', icon: 'ri-presentation-line', desc: 'Практический тренинг: минимум теории, максимум упражнений, кейсов и разбора реальных ситуаций.' },
  { step: '05', title: 'Практика', icon: 'ri-tools-fill', desc: 'Переговорные поединки, деловые игры, разбор звонков и диалогов — закрепление навыков.' },
  { step: '06', title: 'Внедрение', icon: 'ri-rocket-2-line', desc: 'Применение новых инструментов в ежедневной работе: скрипты, чек-листы, алгоритмы действий.' },
  { step: '07', title: 'Сопровождение', icon: 'ri-chat-smile-3-line', desc: 'Посттренинговое сопровождение: контрольные встречи, обратная связь, корректировка навыков.' },
  { step: '08', title: 'Измерение результата', icon: 'ri-bar-chart-box-line', desc: 'Сравнение KPI до и после обучения: конверсия, средний чек, повторные продажи, скорость сделок.' },
];

export default function ProjectTimeline() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Как проходит проект
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-14 max-w-3xl mx-auto">
          Прозрачный процесс — от первого контакта до измеримых результатов
        </p>

        <div className="relative">
          {/* Vertical line */}
          <div className="absolute left-6 md:left-1/2 top-0 bottom-0 w-0.5 bg-teal-200 hidden md:block -translate-x-px"></div>
          <div className="absolute left-6 top-0 bottom-0 w-0.5 bg-teal-200 md:hidden"></div>

          <div className="space-y-8 md:space-y-0 relative">
            {phases.map((phase, i) => (
              <div key={i} className={`relative flex items-start gap-6 md:gap-0 ${i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                {/* Center dot */}
                <div className="absolute left-6 md:left-1/2 w-5 h-5 bg-teal-600 rounded-full border-4 border-white z-10 -translate-x-1/2 shadow-sm"></div>

                {/* Content */}
                <div className={`ml-14 md:ml-0 md:w-1/2 ${i % 2 === 0 ? 'md:pr-10' : 'md:pl-10'}`}>
                  <div className="bg-gray-50 rounded-xl p-4 md:p-5 hover:bg-teal-50 transition-all group border border-gray-100">
                    <div className="flex items-center gap-3 mb-2">
                      <div className="w-10 h-10 bg-teal-600 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform">
                        <i className={`${phase.icon} text-base text-white`}></i>
                      </div>
                      <div>
                        <span className="text-xs font-bold text-teal-600">{phase.step}</span>
                        <h3 className="font-bold text-gray-900 text-sm">{phase.title}</h3>
                      </div>
                    </div>
                    <p className="text-gray-600 text-xs md:text-sm leading-relaxed">{phase.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}